import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import { FlipcardState } from './flipcard-interfaces';

@injectable()
export class FlipcardStateProtobufSerializer implements SerializationApi.StateSerializationPlugin<FlipcardState> {

  key = { id: 34, name: { ns: 'interaction-suspend-data', name: 'flipcard' }, format: 'protobuf' }

  serialize(data: FlipcardState): Result<Uint8Array, SerializationApi.SerializerError> {

    const message = new FlipcardStateProtoMessage({
      activeIndex: data.activeIndex,
      touched: data.touched,
    })

    return ProtobufSerializer.serialize<FlipcardStateProtoMessage>(message, FlipcardStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<FlipcardState, SerializationApi.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<FlipcardStateProtoMessage>(content, FlipcardStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value
    const result: FlipcardState = {
      activeIndex: message.activeIndex,
      touched: message.touched,
    }
    
    return ok(result)
  }
}

@Type.d('FlipcardStateProtoMessage')
class FlipcardStateProtoMessage extends Message<FlipcardStateProtoMessage> {
  @Field.d(1, 'int32', 'optional', 0)
  activeIndex: number;

  @Field.d(2, 'bool', 'repeated')
  touched: boolean[];
}
